/**
 * Picks v2 or v1 of the Daily Inspirations page based on the redesign
 * flag. Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import DailyReflectionPage   from './DailyReflectionPage';
import DailyReflectionPageV2 from './DailyReflectionPageV2';

export default function DailyReflectionPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? DailyReflectionPageV2 : DailyReflectionPage;
  return <Component {...props} />;
}
